/**
 * @generated SignedSource<<b121bb6e47c4de6ef6cbdf9c0bd5bad2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LearnableKind = "Course" | "GroupCoaching" | "MicroLearning" | "OneToOneCoaching";
export type licensesTabRefetchQuery$variables = {
  kinds: ReadonlyArray<LearnableKind>;
  licensesAvailable?: boolean | null;
  licensesConsumed?: boolean | null;
  text?: string | null;
};
export type licensesTabRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"licensesTab_LicensesTabFragment">;
};
export type licensesTabRefetchQuery = {
  response: licensesTabRefetchQuery$data;
  variables: licensesTabRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "kinds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "licensesAvailable"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "licensesConsumed"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "text"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "kinds",
    "variableName": "kinds"
  },
  {
    "kind": "Variable",
    "name": "licensesAvailable",
    "variableName": "licensesAvailable"
  },
  {
    "kind": "Variable",
    "name": "licensesConsumed",
    "variableName": "licensesConsumed"
  },
  {
    "kind": "Variable",
    "name": "text",
    "variableName": "text"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "ContractPartner",
  "kind": "LinkedField",
  "name": "contractPartner",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContractPartnerData",
      "kind": "LinkedField",
      "name": "data",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linkToAGB",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "File",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnail",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v8 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CoachingOfferDescription",
    "kind": "LinkedField",
    "name": "description",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/)
    ],
    "storageKey": null
  }
],
v9 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnOpportunityV2",
    "kind": "LinkedField",
    "name": "root",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "structureDefinition",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "extension",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isMicroLearning",
                                "storageKey": null
                              },
                              (v6/*: any*/)
                            ],
                            "type": "PublishedConstellationRootExtensionExtension",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PublishedRootExtensionImpl",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "LearnOpportunityRootStructureDefinition",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      (v7/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "licensesTabRefetchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "licensesTab_LicensesTabFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "licensesTabRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LicenseGroupingQueries",
        "kind": "LinkedField",
        "name": "LicenseGrouping",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "LicenseGroupingsConnection",
            "kind": "LinkedField",
            "name": "MyLicenses",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LicenseGroupingsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isLicenseGrouping"
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalLicenseAmount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "usedLicenseAmount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalLicenseAmountForUser",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "usedLicenseAmountForUser",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "assignmentRules",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "licenseGroupingId",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "learnable",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CoachingOffer",
                                    "kind": "LinkedField",
                                    "name": "groupCoaching",
                                    "plural": false,
                                    "selections": (v8/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "PublishedGroupCoachingLearnable",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CoachingOffer",
                                    "kind": "LinkedField",
                                    "name": "oneToOneCoaching",
                                    "plural": false,
                                    "selections": (v8/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "PublishedOneToOneCoachingLearnable",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "PublishedCourseLearnable",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v9/*: any*/),
                                "type": "PublishedMicroLearningLearnable",
                                "abstractKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "LearnableLicenseGrouping",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2f9d35f04a4a7c77843b421acdf8051b",
    "id": null,
    "metadata": {},
    "name": "licensesTabRefetchQuery",
    "operationKind": "query",
    "text": "query licensesTabRefetchQuery(\n  $kinds: [LearnableKind!]!\n  $licensesAvailable: Boolean\n  $licensesConsumed: Boolean\n  $text: String\n) {\n  ...licensesTab_LicensesTabFragment_3gxbnK\n}\n\nfragment licensesGroupCard_LicenseGroupingFragment on LicenseGrouping {\n  __isLicenseGrouping: __typename\n  id\n  kind\n  totalLicenseAmount\n  usedLicenseAmount\n  totalLicenseAmountForUser\n  usedLicenseAmountForUser\n  assignmentRules {\n    __typename\n    licenseGroupingId\n    id\n  }\n  ... on MicroLearningLicenseGrouping {\n    id\n  }\n  ... on LearnableLicenseGrouping {\n    learnable {\n      __typename\n      kind\n      ... on PublishedGroupCoachingLearnable {\n        groupCoaching {\n          id\n          description {\n            contractPartner {\n              data {\n                name\n                linkToAGB\n              }\n              id\n            }\n            name\n            image {\n              thumbnail\n              id\n            }\n          }\n        }\n      }\n      ... on PublishedOneToOneCoachingLearnable {\n        oneToOneCoaching {\n          id\n          description {\n            contractPartner {\n              data {\n                name\n                linkToAGB\n              }\n              id\n            }\n            name\n            image {\n              thumbnail\n              id\n            }\n          }\n        }\n      }\n      ... on PublishedCourseLearnable {\n        root {\n          structureDefinition {\n            __typename\n            title\n            ... on LearnOpportunityRootStructureDefinition {\n              extension {\n                __typename\n                ... on PublishedRootExtensionImpl {\n                  extension {\n                    __typename\n                    ... on PublishedConstellationRootExtensionExtension {\n                      isMicroLearning\n                      contractPartner {\n                        data {\n                          name\n                          linkToAGB\n                        }\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          id\n          description\n          image {\n            thumbnail\n            id\n          }\n        }\n      }\n      ... on PublishedMicroLearningLearnable {\n        root {\n          structureDefinition {\n            __typename\n            title\n            ... on LearnOpportunityRootStructureDefinition {\n              extension {\n                __typename\n                ... on PublishedRootExtensionImpl {\n                  extension {\n                    __typename\n                    ... on PublishedConstellationRootExtensionExtension {\n                      isMicroLearning\n                      contractPartner {\n                        data {\n                          name\n                          linkToAGB\n                        }\n                        id\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          id\n          description\n          image {\n            thumbnail\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment licensesTab_LicensesTabFragment_3gxbnK on Query {\n  LicenseGrouping {\n    MyLicenses(kinds: $kinds, licensesAvailable: $licensesAvailable, licensesConsumed: $licensesConsumed, text: $text) {\n      edges {\n        node {\n          __typename\n          id\n          ...licensesGroupCard_LicenseGroupingFragment\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aca0b949feb51eaa8b5bd5b14df7fdbd";

export default node;
